<script setup lang="ts">
defineProps<{
  modelValue?: boolean;
  type?: "checkbox" | "radio";
  id?: string;
  name?: string;
  disabled?: boolean;
  ariaLabel?: string;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: boolean];
  change: [value: boolean];
}>();

function onChange(event: Event) {
  const value = (event.target as HTMLInputElement).checked;
  emit("update:modelValue", value);
  emit("change", value);
}
</script>

<template>
  <input
    :id="id"
    :name="name"
    :type="type ?? 'checkbox'"
    :checked="modelValue"
    :disabled="disabled"
    :aria-label="ariaLabel"
    class="size-4 accent-[var(--pn-brand)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--pn-selection-ring)] disabled:cursor-not-allowed disabled:opacity-55"
    @change="onChange"
  />
</template>
